// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ChatGPT-like Minimalistic Chat Design */
.chat-container {
  display: flex;
  flex-direction: column;
  height: 600px;
  background-color: rgba(31, 41, 55, 0.5);
  border: 1px solid rgba(75, 85, 99, 0.3);
  border-radius: 0.75rem;
  overflow: hidden;
}

/* Empty State */
.chat-empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  text-align: center;
  padding: 2rem;
}


.empty-title {
  font-size: 1.25rem;
  font-weight: 600;
  color: rgb(255, 255, 255);
  margin-bottom: 0.5rem;
}

.empty-description {
  color: rgb(156, 163, 175);
  font-size: 0.875rem;
  line-height: 1.5;
  max-width: 300px;
}

/* Messages Area */
.chat-messages {
  flex: 1 1;
  overflow-y: auto;
  padding: 0;
  margin: 0;
  background: transparent;
  border: none;
}

/* Welcome State */
.chat-welcome {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  text-align: center;
  padding: 2rem;
}



.welcome-title {
  font-size: 1.5rem;
  font-weight: 600;
  color: rgb(255, 255, 255);
  margin-bottom: 0.5rem;
}

.welcome-subtitle {
  color: rgb(156, 163, 175);
  font-size: 1rem;
  line-height: 1.5;
  max-width: 400px;
}

/* Messages List */
.messages-list {
  padding: 1rem 0;
}

/* Individual Message */
.message {
  display: flex;
  gap: 0.75rem;
  margin-bottom: 1.5rem;
  padding: 0 1rem;
  align-items: flex-start;
}

.message.user {
  flex-direction: row-reverse;
}

/* Message Avatars */
.message-avatar {
  flex-shrink: 0;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  font-size: 0.75rem;
  font-weight: 500;
}

.user-avatar {
  background: rgb(16, 163, 127);
  color: white;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.75rem;
  font-weight: 600;
}

.bot-avatar {
  background: transparent;
  color: white;
  font-size: 1.25rem;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Message Content */
.message-content {
  flex: 1 1;
  max-width: calc(100% - 48px);
  word-wrap: break-word;
  line-height: 1.6;
  text-align: left;
}

.user-message-text {
  background: rgb(52, 53, 65);
  color: rgb(255, 255, 255);
  padding: 0.75rem 1rem;
  border-radius: 1rem;
  font-size: 0.95rem;
  line-height: 1.5;
  max-width: fit-content;
  margin-left: auto;
}

.message.bot .message-content {
  color: rgb(236, 236, 241);
  font-size: 0.95rem;
  line-height: 1.6;
  text-align: left;
}

/* Typing Indicator */
.typing-indicator {
  display: flex;
  gap: 0.25rem;
  padding: 0.75rem 0;
}

.typing-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: rgb(156, 163, 175);
  animation: typing 1.4s infinite ease-in-out;
}

.typing-dot:nth-child(1) {
  animation-delay: -0.32s;
}

.typing-dot:nth-child(2) {
  animation-delay: -0.16s;
}

@keyframes typing {
  0%, 80%, 100% {
    transform: scale(0.8);
    opacity: 0.5;
  }
  40% {
    transform: scale(1);
    opacity: 1;
  }
}

/* Input Area */
.chat-input-area {
  padding: 1rem;
  border-top: 1px solid rgba(55, 65, 81, 0.3);
  background: transparent;
}

.input-container {
  position: relative;
  max-width: 100%;
  margin: 0 auto;
}

.chat-input {
  width: 100%;
  min-height: 44px;
  max-height: 120px;
  padding: 0.75rem 3rem 0.75rem 1rem;
  background: rgb(64, 65, 79);
  border: 1px solid rgba(86, 88, 105, 0.5);
  border-radius: 0.75rem;
  color: rgb(255, 255, 255);
  font-size: 1rem;
  line-height: 1.5;
  resize: none;
  outline: none;
  transition: all 0.2s ease;
  font-family: inherit;
}

.chat-input:focus {
  border-color: rgba(86, 88, 105, 0.8);
  box-shadow: 0 0 0 2px rgba(86, 88, 105, 0.2);
}

.chat-input:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.chat-input::placeholder {
  color: rgb(156, 163, 175);
}

.send-button {
  position: absolute;
  right: 0.5rem;
  top: 50%;
  transform: translateY(-50%);
  width: 32px;
  height: 32px;
  background: rgb(25, 195, 125);
  border: none;
  border-radius: 0.375rem;
  color: white;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  opacity: 1;
}

.send-button:hover:not(:disabled) {
  background: rgb(16, 163, 127);
}

.send-button:disabled {
  background: rgb(86, 88, 105);
  cursor: not-allowed;
  opacity: 0.5;
}

.send-button svg {
  width: 16px;
  height: 16px;
}

/* Utility Classes for Markdown */
.text-lg { font-size: 1.125rem; line-height: 1.75rem; }
.text-base { font-size: 1rem; line-height: 1.5rem; }
.text-sm { font-size: 0.875rem; line-height: 1.25rem; }
.font-semibold { font-weight: 600; }
.font-medium { font-weight: 500; }
.text-white { color: rgb(255, 255, 255); }
.text-gray-200 { color: rgb(229, 231, 235); }
.text-gray-300 { color: rgb(209, 213, 219); }
.text-blue-300 { color: rgb(147, 197, 253); }
.text-blue-400 { color: rgb(96, 165, 250); }
.leading-relaxed { line-height: 1.625; }
.mb-3 { margin-bottom: 0.75rem; }
.mb-2 { margin-bottom: 0.5rem; }
.mt-4 { margin-top: 1rem; }
.mt-3 { margin-top: 0.75rem; }
.mt-2 { margin-top: 0.5rem; }
.ml-4 { margin-left: 1rem; }
.my-3 { margin-top: 0.75rem; margin-bottom: 0.75rem; }
.list-none { list-style-type: none; }
.list-decimal { list-style-type: decimal; }
.list-inside { list-style-position: inside; }
.space-y-1 > * + * { margin-top: 0.25rem; }
.flex { display: flex; }
.items-start { align-items: flex-start; }
.gap-2 { gap: 0.5rem; }
.w-1\\.5 { width: 0.375rem; }
.h-1\\.5 { height: 0.375rem; }
.bg-blue-400 { background-color: rgb(96, 165, 250); }
.rounded-full { border-radius: 9999px; }
.flex-shrink-0 { flex-shrink: 0; }
.bg-gray-700\\/60 { background-color: rgba(55, 65, 81, 0.6); }
.px-1\\.5 { padding-left: 0.375rem; padding-right: 0.375rem; }
.py-0\\.5 { padding-top: 0.125rem; padding-bottom: 0.125rem; }
.rounded { border-radius: 0.25rem; }
.font-mono { font-family: ui-monospace, SFMono-Regular, monospace; }
.border-l-3 { border-left-width: 3px; }
.border-blue-400\\/50 { border-color: rgba(96, 165, 250, 0.5); }
.bg-blue-400\\/10 { background-color: rgba(96, 165, 250, 0.1); }
.pl-3 { padding-left: 0.75rem; }
.py-2 { padding-top: 0.5rem; padding-bottom: 0.5rem; }
.underline { text-decoration-line: underline; }
.transition-colors { transition: color 0.15s ease; }
.hover\\:text-blue-300:hover { color: rgb(147, 197, 253); }
.italic { font-style: italic; }

/* Markdown Styling in Messages */
.message.bot .message-content h1,
.message.bot .message-content h2,
.message.bot .message-content h3 {
  margin-top: 1rem;
  margin-bottom: 0.5rem;
}

.message.bot .message-content h1:first-child,
.message.bot .message-content h2:first-child,
.message.bot .message-content h3:first-child {
  margin-top: 0;
}

.message.bot .message-content p:last-child {
  margin-bottom: 0;
}

.message.bot .message-content ul,
.message.bot .message-content ol {
  margin: 0.75rem 0;
}

.message.bot .message-content li {
  margin-bottom: 0.25rem;
}

.message.bot .message-content pre {
  margin: 1rem 0;
  border-radius: 0.5rem;
  overflow-x: auto;
}

.message.bot .message-content blockquote {
  margin: 1rem 0;
  border-radius: 0.375rem;
}

/* Custom Scrollbar */
.chat-messages::-webkit-scrollbar {
  width: 4px;
}

.chat-messages::-webkit-scrollbar-track {
  background: transparent;
}

.chat-messages::-webkit-scrollbar-thumb {
  background: rgba(156, 163, 175, 0.3);
  border-radius: 2px;
}

.chat-messages::-webkit-scrollbar-thumb:hover {
  background: rgba(156, 163, 175, 0.5);
}

/* Responsive Design */
@media (max-width: 768px) {
  .chat-container {
    height: 500px;
  }
  
  .message {
    padding: 0 0.75rem;
  }
  
  .chat-input-area {
    padding: 0.75rem;
  }
  
  .welcome-title {
    font-size: 1.25rem;
  }
  
  .welcome-subtitle {
    font-size: 0.875rem;
  }
}

@media (max-width: 480px) {
  .chat-container {
    height: 450px;
  }
  
  .message {
    padding: 0 0.5rem;
    gap: 0.5rem;
  }
  
  .message-avatar {
    width: 28px;
    height: 28px;
  }
  
  .user-avatar,
  .bot-avatar {
    width: 28px;
    height: 28px;
    font-size: 0.7rem;
  }
  
  .bot-avatar {
    font-size: 1rem;
  }
  
  .chat-input {
    font-size: 0.9rem;
    padding: 0.6rem 2.5rem 0.6rem 0.75rem;
  }
  
  .send-button {
    width: 28px;
    height: 28px;
    right: 0.4rem;
  }
  
  .send-button svg {
    width: 14px;
    height: 14px;
  }
}

/* Message preset styling */
.preset-message {
  background: linear-gradient(145deg, rgba(59, 130, 246, 0.15), rgba(99, 102, 241, 0.1));
  border: 1px solid rgba(59, 130, 246, 0.3);
  border-radius: 12px;
  padding: 4px;
  margin-bottom: 8px;
}

.preset-indicator {
  background: linear-gradient(90deg, rgba(59, 130, 246, 0.8), rgba(99, 102, 241, 0.8));
  color: white;
  font-size: 0.75rem;
  font-weight: 600;
  padding: 4px 8px;
  border-radius: 8px 8px 0 0;
  margin: -4px -4px 8px -4px;
  text-align: left;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  animation: slideInDown 0.3s ease-out;
}

@keyframes slideInDown {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Preset message content adjustments */
.preset-message .message-content {
  padding: 8px 12px;
}

.preset-message .bot-avatar {
  background: linear-gradient(135deg, rgba(59, 130, 246, 0.8), rgba(99, 102, 241, 0.8));
  border: 2px solid rgba(255, 255, 255, 0.2);
}

/* Enhanced animation for preset messages */
.preset-message {
  animation: slideInUp 0.5s ease-out;
}

@keyframes slideInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* KaTeX Math Rendering Styles for Chat */
.message.bot .katex {
  color: rgb(229, 231, 235) !important;
  font-size: 1.1em !important;
}

.message.bot .katex .katex-html {
  color: rgb(229, 231, 235) !important;
}

.message.bot .katex-display {
  margin: 1.5rem 0 !important;
  text-align: center !important;
}

.message.bot .katex-display .katex {
  display: inline-block !important;
  background-color: rgba(31, 41, 55, 0.4) !important;
  padding: 1rem 1.5rem !important;
  border-radius: 0.5rem !important;
  border: 1px solid rgba(75, 85, 99, 0.3) !important;
  color: white !important;
}

.message.bot .katex .base {
  color: rgb(229, 231, 235) !important;
}

.message.bot .katex .mord, 
.message.bot .katex .mbin, 
.message.bot .katex .mrel, 
.message.bot .katex .mopen, 
.message.bot .katex .mclose, 
.message.bot .katex .mpunct {
  color: rgb(229, 231, 235) !important;
}

.message.bot .katex .accent > .vlist-t > .vlist-r > .vlist > .vlist-elem {
  color: rgb(96, 165, 250) !important;
}

.message.bot .katex .frac-line {
  border-bottom-color: rgb(156, 163, 175) !important;
}

.message.bot .katex .sqrt > .vlist-t > .vlist-r > .vlist > .vlist-elem:first-child {
  border-color: rgb(156, 163, 175) !important;
}

/* Inline math in chat */
.message.bot .katex:not(.katex-display) {
  background-color: rgba(55, 65, 81, 0.6) !important;
  padding: 0.2rem 0.4rem !important;
  border-radius: 0.25rem !important;
  border: 1px solid rgba(75, 85, 99, 0.3) !important;
  margin: 0 0.1rem !important;
} `, "",{"version":3,"sources":["webpack://./src/components/VideoTabs/ChatTab.css"],"names":[],"mappings":"AAAA,0CAA0C;AAC1C;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,uCAAuC;EACvC,uCAAuC;EACvC,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,aAAa;AACf;;;AAGA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,SAAO;EACP,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,uBAAuB;EACvB,YAAY;AACd;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,aAAa;AACf;;;;AAIA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,eAAe;AACjB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,YAAY;EACZ,qBAAqB;EACrB,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,oBAAoB;AACpB;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,oBAAoB;AACpB;EACE,SAAO;EACP,4BAA4B;EAC5B,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,8BAA8B;EAC9B,2CAA2C;AAC7C;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE;IACE,qBAAqB;IACrB,YAAY;EACd;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;AACF;;AAEA,eAAe;AACf;EACE,aAAa;EACb,2CAA2C;EAC3C,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,kCAAkC;EAClC,2BAA2B;EAC3B,wCAAwC;EACxC,sBAAsB;EACtB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,oCAAoC;EACpC,4CAA4C;AAC9C;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,YAAY;EACZ,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,4BAA4B;EAC5B,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,iCAAiC;AACjC,WAAW,mBAAmB,EAAE,oBAAoB,EAAE;AACtD,aAAa,eAAe,EAAE,mBAAmB,EAAE;AACnD,WAAW,mBAAmB,EAAE,oBAAoB,EAAE;AACtD,iBAAiB,gBAAgB,EAAE;AACnC,eAAe,gBAAgB,EAAE;AACjC,cAAc,yBAAyB,EAAE;AACzC,iBAAiB,yBAAyB,EAAE;AAC5C,iBAAiB,yBAAyB,EAAE;AAC5C,iBAAiB,yBAAyB,EAAE;AAC5C,iBAAiB,wBAAwB,EAAE;AAC3C,mBAAmB,kBAAkB,EAAE;AACvC,QAAQ,sBAAsB,EAAE;AAChC,QAAQ,qBAAqB,EAAE;AAC/B,QAAQ,gBAAgB,EAAE;AAC1B,QAAQ,mBAAmB,EAAE;AAC7B,QAAQ,kBAAkB,EAAE;AAC5B,QAAQ,iBAAiB,EAAE;AAC3B,QAAQ,mBAAmB,EAAE,sBAAsB,EAAE;AACrD,aAAa,qBAAqB,EAAE;AACpC,gBAAgB,wBAAwB,EAAE;AAC1C,eAAe,2BAA2B,EAAE;AAC5C,qBAAqB,mBAAmB,EAAE;AAC1C,QAAQ,aAAa,EAAE;AACvB,eAAe,uBAAuB,EAAE;AACxC,SAAS,WAAW,EAAE;AACtB,UAAU,eAAe,EAAE;AAC3B,UAAU,gBAAgB,EAAE;AAC5B,eAAe,mCAAmC,EAAE;AACpD,gBAAgB,qBAAqB,EAAE;AACvC,iBAAiB,cAAc,EAAE;AACjC,mBAAmB,uCAAuC,EAAE;AAC5D,WAAW,sBAAsB,EAAE,uBAAuB,EAAE;AAC5D,WAAW,qBAAqB,EAAE,wBAAwB,EAAE;AAC5D,WAAW,sBAAsB,EAAE;AACnC,aAAa,oDAAoD,EAAE;AACnE,cAAc,sBAAsB,EAAE;AACtC,uBAAuB,qCAAqC,EAAE;AAC9D,mBAAmB,yCAAyC,EAAE;AAC9D,QAAQ,qBAAqB,EAAE;AAC/B,QAAQ,mBAAmB,EAAE,sBAAsB,EAAE;AACrD,aAAa,+BAA+B,EAAE;AAC9C,qBAAqB,4BAA4B,EAAE;AACnD,8BAA8B,yBAAyB,EAAE;AACzD,UAAU,kBAAkB,EAAE;;AAE9B,iCAAiC;AACjC;;;EAGE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;;;EAGE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,uBAAuB;AACzB;;AAEA,qBAAqB;AACrB;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;AACtC;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,WAAW;EACb;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;;IAEE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,qCAAqC;EACvC;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA,2BAA2B;AAC3B;EACE,sFAAsF;EACtF,yCAAyC;EACzC,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,oFAAoF;EACpF,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,0BAA0B;EAC1B,0BAA0B;EAC1B,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,uCAAuC;AACvC;EACE,iBAAiB;AACnB;;AAEA;EACE,qFAAqF;EACrF,0CAA0C;AAC5C;;AAEA,2CAA2C;AAC3C;EACE,kCAAkC;AACpC;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,yCAAyC;AACzC;EACE,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;EACE,gCAAgC;EAChC,kDAAkD;EAClD,+BAA+B;EAC/B,gCAAgC;EAChC,kDAAkD;EAClD,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;;;;;EAME,oCAAoC;AACtC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,2CAA2C;AAC7C;;AAEA,wBAAwB;AACxB;EACE,kDAAkD;EAClD,iCAAiC;EACjC,iCAAiC;EACjC,kDAAkD;EAClD,2BAA2B;AAC7B","sourcesContent":["/* ChatGPT-like Minimalistic Chat Design */\n.chat-container {\n  display: flex;\n  flex-direction: column;\n  height: 600px;\n  background-color: rgba(31, 41, 55, 0.5);\n  border: 1px solid rgba(75, 85, 99, 0.3);\n  border-radius: 0.75rem;\n  overflow: hidden;\n}\n\n/* Empty State */\n.chat-empty-state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  text-align: center;\n  padding: 2rem;\n}\n\n\n.empty-title {\n  font-size: 1.25rem;\n  font-weight: 600;\n  color: rgb(255, 255, 255);\n  margin-bottom: 0.5rem;\n}\n\n.empty-description {\n  color: rgb(156, 163, 175);\n  font-size: 0.875rem;\n  line-height: 1.5;\n  max-width: 300px;\n}\n\n/* Messages Area */\n.chat-messages {\n  flex: 1;\n  overflow-y: auto;\n  padding: 0;\n  margin: 0;\n  background: transparent;\n  border: none;\n}\n\n/* Welcome State */\n.chat-welcome {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  text-align: center;\n  padding: 2rem;\n}\n\n\n\n.welcome-title {\n  font-size: 1.5rem;\n  font-weight: 600;\n  color: rgb(255, 255, 255);\n  margin-bottom: 0.5rem;\n}\n\n.welcome-subtitle {\n  color: rgb(156, 163, 175);\n  font-size: 1rem;\n  line-height: 1.5;\n  max-width: 400px;\n}\n\n/* Messages List */\n.messages-list {\n  padding: 1rem 0;\n}\n\n/* Individual Message */\n.message {\n  display: flex;\n  gap: 0.75rem;\n  margin-bottom: 1.5rem;\n  padding: 0 1rem;\n  align-items: flex-start;\n}\n\n.message.user {\n  flex-direction: row-reverse;\n}\n\n/* Message Avatars */\n.message-avatar {\n  flex-shrink: 0;\n  width: 32px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  font-size: 0.75rem;\n  font-weight: 500;\n}\n\n.user-avatar {\n  background: rgb(16, 163, 127);\n  color: white;\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 0.75rem;\n  font-weight: 600;\n}\n\n.bot-avatar {\n  background: transparent;\n  color: white;\n  font-size: 1.25rem;\n  width: 32px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n/* Message Content */\n.message-content {\n  flex: 1;\n  max-width: calc(100% - 48px);\n  word-wrap: break-word;\n  line-height: 1.6;\n  text-align: left;\n}\n\n.user-message-text {\n  background: rgb(52, 53, 65);\n  color: rgb(255, 255, 255);\n  padding: 0.75rem 1rem;\n  border-radius: 1rem;\n  font-size: 0.95rem;\n  line-height: 1.5;\n  max-width: fit-content;\n  margin-left: auto;\n}\n\n.message.bot .message-content {\n  color: rgb(236, 236, 241);\n  font-size: 0.95rem;\n  line-height: 1.6;\n  text-align: left;\n}\n\n/* Typing Indicator */\n.typing-indicator {\n  display: flex;\n  gap: 0.25rem;\n  padding: 0.75rem 0;\n}\n\n.typing-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: rgb(156, 163, 175);\n  animation: typing 1.4s infinite ease-in-out;\n}\n\n.typing-dot:nth-child(1) {\n  animation-delay: -0.32s;\n}\n\n.typing-dot:nth-child(2) {\n  animation-delay: -0.16s;\n}\n\n@keyframes typing {\n  0%, 80%, 100% {\n    transform: scale(0.8);\n    opacity: 0.5;\n  }\n  40% {\n    transform: scale(1);\n    opacity: 1;\n  }\n}\n\n/* Input Area */\n.chat-input-area {\n  padding: 1rem;\n  border-top: 1px solid rgba(55, 65, 81, 0.3);\n  background: transparent;\n}\n\n.input-container {\n  position: relative;\n  max-width: 100%;\n  margin: 0 auto;\n}\n\n.chat-input {\n  width: 100%;\n  min-height: 44px;\n  max-height: 120px;\n  padding: 0.75rem 3rem 0.75rem 1rem;\n  background: rgb(64, 65, 79);\n  border: 1px solid rgba(86, 88, 105, 0.5);\n  border-radius: 0.75rem;\n  color: rgb(255, 255, 255);\n  font-size: 1rem;\n  line-height: 1.5;\n  resize: none;\n  outline: none;\n  transition: all 0.2s ease;\n  font-family: inherit;\n}\n\n.chat-input:focus {\n  border-color: rgba(86, 88, 105, 0.8);\n  box-shadow: 0 0 0 2px rgba(86, 88, 105, 0.2);\n}\n\n.chat-input:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.chat-input::placeholder {\n  color: rgb(156, 163, 175);\n}\n\n.send-button {\n  position: absolute;\n  right: 0.5rem;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 32px;\n  height: 32px;\n  background: rgb(25, 195, 125);\n  border: none;\n  border-radius: 0.375rem;\n  color: white;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s ease;\n  opacity: 1;\n}\n\n.send-button:hover:not(:disabled) {\n  background: rgb(16, 163, 127);\n}\n\n.send-button:disabled {\n  background: rgb(86, 88, 105);\n  cursor: not-allowed;\n  opacity: 0.5;\n}\n\n.send-button svg {\n  width: 16px;\n  height: 16px;\n}\n\n/* Utility Classes for Markdown */\n.text-lg { font-size: 1.125rem; line-height: 1.75rem; }\n.text-base { font-size: 1rem; line-height: 1.5rem; }\n.text-sm { font-size: 0.875rem; line-height: 1.25rem; }\n.font-semibold { font-weight: 600; }\n.font-medium { font-weight: 500; }\n.text-white { color: rgb(255, 255, 255); }\n.text-gray-200 { color: rgb(229, 231, 235); }\n.text-gray-300 { color: rgb(209, 213, 219); }\n.text-blue-300 { color: rgb(147, 197, 253); }\n.text-blue-400 { color: rgb(96, 165, 250); }\n.leading-relaxed { line-height: 1.625; }\n.mb-3 { margin-bottom: 0.75rem; }\n.mb-2 { margin-bottom: 0.5rem; }\n.mt-4 { margin-top: 1rem; }\n.mt-3 { margin-top: 0.75rem; }\n.mt-2 { margin-top: 0.5rem; }\n.ml-4 { margin-left: 1rem; }\n.my-3 { margin-top: 0.75rem; margin-bottom: 0.75rem; }\n.list-none { list-style-type: none; }\n.list-decimal { list-style-type: decimal; }\n.list-inside { list-style-position: inside; }\n.space-y-1 > * + * { margin-top: 0.25rem; }\n.flex { display: flex; }\n.items-start { align-items: flex-start; }\n.gap-2 { gap: 0.5rem; }\n.w-1\\.5 { width: 0.375rem; }\n.h-1\\.5 { height: 0.375rem; }\n.bg-blue-400 { background-color: rgb(96, 165, 250); }\n.rounded-full { border-radius: 9999px; }\n.flex-shrink-0 { flex-shrink: 0; }\n.bg-gray-700\\/60 { background-color: rgba(55, 65, 81, 0.6); }\n.px-1\\.5 { padding-left: 0.375rem; padding-right: 0.375rem; }\n.py-0\\.5 { padding-top: 0.125rem; padding-bottom: 0.125rem; }\n.rounded { border-radius: 0.25rem; }\n.font-mono { font-family: ui-monospace, SFMono-Regular, monospace; }\n.border-l-3 { border-left-width: 3px; }\n.border-blue-400\\/50 { border-color: rgba(96, 165, 250, 0.5); }\n.bg-blue-400\\/10 { background-color: rgba(96, 165, 250, 0.1); }\n.pl-3 { padding-left: 0.75rem; }\n.py-2 { padding-top: 0.5rem; padding-bottom: 0.5rem; }\n.underline { text-decoration-line: underline; }\n.transition-colors { transition: color 0.15s ease; }\n.hover\\:text-blue-300:hover { color: rgb(147, 197, 253); }\n.italic { font-style: italic; }\n\n/* Markdown Styling in Messages */\n.message.bot .message-content h1,\n.message.bot .message-content h2,\n.message.bot .message-content h3 {\n  margin-top: 1rem;\n  margin-bottom: 0.5rem;\n}\n\n.message.bot .message-content h1:first-child,\n.message.bot .message-content h2:first-child,\n.message.bot .message-content h3:first-child {\n  margin-top: 0;\n}\n\n.message.bot .message-content p:last-child {\n  margin-bottom: 0;\n}\n\n.message.bot .message-content ul,\n.message.bot .message-content ol {\n  margin: 0.75rem 0;\n}\n\n.message.bot .message-content li {\n  margin-bottom: 0.25rem;\n}\n\n.message.bot .message-content pre {\n  margin: 1rem 0;\n  border-radius: 0.5rem;\n  overflow-x: auto;\n}\n\n.message.bot .message-content blockquote {\n  margin: 1rem 0;\n  border-radius: 0.375rem;\n}\n\n/* Custom Scrollbar */\n.chat-messages::-webkit-scrollbar {\n  width: 4px;\n}\n\n.chat-messages::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.chat-messages::-webkit-scrollbar-thumb {\n  background: rgba(156, 163, 175, 0.3);\n  border-radius: 2px;\n}\n\n.chat-messages::-webkit-scrollbar-thumb:hover {\n  background: rgba(156, 163, 175, 0.5);\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .chat-container {\n    height: 500px;\n  }\n  \n  .message {\n    padding: 0 0.75rem;\n  }\n  \n  .chat-input-area {\n    padding: 0.75rem;\n  }\n  \n  .welcome-title {\n    font-size: 1.25rem;\n  }\n  \n  .welcome-subtitle {\n    font-size: 0.875rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .chat-container {\n    height: 450px;\n  }\n  \n  .message {\n    padding: 0 0.5rem;\n    gap: 0.5rem;\n  }\n  \n  .message-avatar {\n    width: 28px;\n    height: 28px;\n  }\n  \n  .user-avatar,\n  .bot-avatar {\n    width: 28px;\n    height: 28px;\n    font-size: 0.7rem;\n  }\n  \n  .bot-avatar {\n    font-size: 1rem;\n  }\n  \n  .chat-input {\n    font-size: 0.9rem;\n    padding: 0.6rem 2.5rem 0.6rem 0.75rem;\n  }\n  \n  .send-button {\n    width: 28px;\n    height: 28px;\n    right: 0.4rem;\n  }\n  \n  .send-button svg {\n    width: 14px;\n    height: 14px;\n  }\n}\n\n/* Message preset styling */\n.preset-message {\n  background: linear-gradient(145deg, rgba(59, 130, 246, 0.15), rgba(99, 102, 241, 0.1));\n  border: 1px solid rgba(59, 130, 246, 0.3);\n  border-radius: 12px;\n  padding: 4px;\n  margin-bottom: 8px;\n}\n\n.preset-indicator {\n  background: linear-gradient(90deg, rgba(59, 130, 246, 0.8), rgba(99, 102, 241, 0.8));\n  color: white;\n  font-size: 0.75rem;\n  font-weight: 600;\n  padding: 4px 8px;\n  border-radius: 8px 8px 0 0;\n  margin: -4px -4px 8px -4px;\n  text-align: left;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  animation: slideInDown 0.3s ease-out;\n}\n\n@keyframes slideInDown {\n  from {\n    opacity: 0;\n    transform: translateY(-10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* Preset message content adjustments */\n.preset-message .message-content {\n  padding: 8px 12px;\n}\n\n.preset-message .bot-avatar {\n  background: linear-gradient(135deg, rgba(59, 130, 246, 0.8), rgba(99, 102, 241, 0.8));\n  border: 2px solid rgba(255, 255, 255, 0.2);\n}\n\n/* Enhanced animation for preset messages */\n.preset-message {\n  animation: slideInUp 0.5s ease-out;\n}\n\n@keyframes slideInUp {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* KaTeX Math Rendering Styles for Chat */\n.message.bot .katex {\n  color: rgb(229, 231, 235) !important;\n  font-size: 1.1em !important;\n}\n\n.message.bot .katex .katex-html {\n  color: rgb(229, 231, 235) !important;\n}\n\n.message.bot .katex-display {\n  margin: 1.5rem 0 !important;\n  text-align: center !important;\n}\n\n.message.bot .katex-display .katex {\n  display: inline-block !important;\n  background-color: rgba(31, 41, 55, 0.4) !important;\n  padding: 1rem 1.5rem !important;\n  border-radius: 0.5rem !important;\n  border: 1px solid rgba(75, 85, 99, 0.3) !important;\n  color: white !important;\n}\n\n.message.bot .katex .base {\n  color: rgb(229, 231, 235) !important;\n}\n\n.message.bot .katex .mord, \n.message.bot .katex .mbin, \n.message.bot .katex .mrel, \n.message.bot .katex .mopen, \n.message.bot .katex .mclose, \n.message.bot .katex .mpunct {\n  color: rgb(229, 231, 235) !important;\n}\n\n.message.bot .katex .accent > .vlist-t > .vlist-r > .vlist > .vlist-elem {\n  color: rgb(96, 165, 250) !important;\n}\n\n.message.bot .katex .frac-line {\n  border-bottom-color: rgb(156, 163, 175) !important;\n}\n\n.message.bot .katex .sqrt > .vlist-t > .vlist-r > .vlist > .vlist-elem:first-child {\n  border-color: rgb(156, 163, 175) !important;\n}\n\n/* Inline math in chat */\n.message.bot .katex:not(.katex-display) {\n  background-color: rgba(55, 65, 81, 0.6) !important;\n  padding: 0.2rem 0.4rem !important;\n  border-radius: 0.25rem !important;\n  border: 1px solid rgba(75, 85, 99, 0.3) !important;\n  margin: 0 0.1rem !important;\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
